<template>
  <div class="index">
    <router-view></router-view>
  </div>
</template>

<script>
export default{
  name:"Index",
  created(){
  }
}
</script>



// WEBPACK FOOTER //
// src/views/sbgl/index.vue